import { render, staticRenderFns } from "./workflowUse.vue?vue&type=template&id=9c97d55c&"
import script from "./workflowUse.vue?vue&type=script&lang=js&"
export * from "./workflowUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c97d55c')) {
      api.createRecord('9c97d55c', component.options)
    } else {
      api.reload('9c97d55c', component.options)
    }
    module.hot.accept("./workflowUse.vue?vue&type=template&id=9c97d55c&", function () {
      api.rerender('9c97d55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/workflow/workflowUse/workflowUse.vue"
export default component.exports